// Photo filenames for Holiday Party 2016
const HOLIDAY_PARTY_2016 = [
  'rolling-thunder-holiday-party-2016-5_31461251042_n.jpg',
  'rolling-thunder-holiday-party-2016-6_31491939121_l.jpg',
  'rolling-thunder-holiday-party-2016-7_31607996865_l.jpg',
  'rolling-thunder-holiday-party-2016-8_30798138333_l.jpg',
  'rolling-thunder-holiday-party-2016-9_31607996275_l.jpg',
  'rolling-thunder-holiday-party-2016-10_30798137783_l.jpg',
  'rolling-thunder-holiday-party-2016-11_31607995405_l.jpg',
  'rolling-thunder-holiday-party-2016-12_30798137173_l.jpg',
  'rolling-thunder-holiday-party-2016-1_31235463970_n.jpg',
  'rolling-thunder-holiday-party-2016-2_31461251552_m.jpg',
  'rolling-thunder-holiday-party-2016-3_31235463850_n.jpg',
  'rolling-thunder-holiday-party-2016-4_31461251432_l.jpg',
];

export default HOLIDAY_PARTY_2016;
